import style from "../style/layout.module.css";
export default function Share({ handleBtn, text }) {
  return (
    <div className={style.athentic} onClick={handleBtn}>
      {text}
    </div>
  );
}
